import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title hide-mobile" }
const _hoisted_4 = { style: {"display":"flex","margin-left":"-10px","margin-top":"5px"} }
const _hoisted_5 = { class: "material-icons" }
const _hoisted_6 = {
  class: "clip",
  style: {"margin-top":"-3px","margin-left":"8px"}
}
const _hoisted_7 = { class: "controls" }
const _hoisted_8 = {
  class: "md-tooltip--bottom",
  "data-md-tooltip": "Install App"
}
const _hoisted_9 = {
  class: "md-tooltip--bottom",
  "data-md-tooltip": "Update Available"
}
const _hoisted_10 = {
  class: "md-tooltip--bottom",
  "data-md-tooltip": "Settings"
}
const _hoisted_11 = {
  class: "md-tooltip--bottom",
  "data-md-tooltip": "Full Screen"
}
const _hoisted_12 = {
  class: "md-tooltip--bottom",
  "data-md-tooltip": "Log Out"
}
const _hoisted_13 = {
  class: "md-tooltip--bottom",
  "data-md-tooltip": "Close"
}
const _hoisted_14 = {
  role: "progressbar",
  class: "mdc-linear-progress",
  "aria-label": "Progress Bar",
  "aria-valuemin": "0",
  "aria-valuemax": "1",
  "aria-valuenow": "0",
  style: {"margin-top":"-8px","z-index":"1000"}
}
const _hoisted_15 = { class: "side-layer-content animate-default" }
const _hoisted_16 = { class: "settings-header" }
const _hoisted_17 = { class: "mdc-list" }
const _hoisted_18 = { style: {"padding":"16px 8px","display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_19 = { class: "mdc-list-item__text" }
const _hoisted_20 = { class: "mdc-switch" }
const _hoisted_21 = { class: "mdc-switch__thumb-underlay" }
const _hoisted_22 = ["checked", "aria-checked"]
const _hoisted_23 = { style: {"padding":"16px 8px","display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_24 = { class: "mdc-list-item__text" }
const _hoisted_25 = { class: "mdc-switch" }
const _hoisted_26 = { class: "mdc-switch__thumb-underlay" }
const _hoisted_27 = ["checked", "aria-checked"]
const _hoisted_28 = {
  class: "mdc-list-item",
  tabindex: "-1"
}
const _hoisted_29 = { style: {"padding":"8px 8px","display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_30 = { style: {"margin-top":"-8px"} }
const _hoisted_31 = {
  class: "mdc-form-field",
  style: {"margin-right":"10px"}
}
const _hoisted_32 = { class: "mdc-radio" }
const _hoisted_33 = {
  class: "mdc-form-field",
  style: {"margin-right":"10px"}
}
const _hoisted_34 = { class: "mdc-radio" }
const _hoisted_35 = { class: "mdc-form-field" }
const _hoisted_36 = { class: "mdc-radio" }
const _hoisted_37 = { style: {"padding":"16px 8px","display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_38 = { class: "mdc-list-item__text" }
const _hoisted_39 = { class: "mdc-switch" }
const _hoisted_40 = { class: "mdc-switch__thumb-underlay" }
const _hoisted_41 = ["checked", "aria-checked"]
const _hoisted_42 = {
  class: "mdc-list-item",
  tabindex: "-1"
}
const _hoisted_43 = { style: {"padding":"8px 8px","display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_44 = { style: {"margin-top":"-8px"} }
const _hoisted_45 = {
  class: "mdc-form-field",
  style: {"margin-right":"10px"}
}
const _hoisted_46 = { class: "mdc-radio" }
const _hoisted_47 = { class: "mdc-form-field" }
const _hoisted_48 = { class: "mdc-radio" }
const _hoisted_49 = { style: {"margin":"32px 16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_progressbar = _resolveDirective("progressbar")!
  const _directive_switch = _resolveDirective("switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", { src: "assets/logo_white.png" })
      ], -1)),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "seperator" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.icon), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.installable)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                tabindex: "1",
                class: "hide-mobile material-icons mdc-top-app-bar__action-item mdc-icon-button hide-mobile",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.install();}),
                "aria-label": "Install App"
              }, "system_update"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.displayUpdate)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                tabindex: "1",
                class: "hide-mobile material-icons mdc-top-app-bar__action-item mdc-icon-button hide-mobile",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.refreshApp();}),
                "aria-label": "System Update"
              }, "update"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("i", {
            tabindex: "1",
            class: "material-icons mdc-top-app-bar__action-item mdc-icon-button",
            "aria-label": "Settings",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.sideLayerOpen = !_ctx.sideLayerOpen;})
          }, "video_settings")
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("i", {
            tabindex: "1",
            id: "full",
            class: "hide-mobile material-icons mdc-top-app-bar__action-item mdc-icon-button hide-mobile",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.toggleFullScreen();}),
            "aria-label": "Full Screen Mode"
          }, _toDisplayString(_ctx.fullscreen ? 'fullscreen_exit': 'fullscreen'), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.routeName === 'Directory')
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                tabindex: "1",
                class: "material-icons mdc-top-app-bar__action-item mdc-icon-button",
                "aria-label": "Log Out",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.logout()))
              }, "logout"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (['Playlist','PlaylistDefault','Install'].indexOf(_ctx.routeName) !== -1)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                tabindex: "1",
                class: "material-icons mdc-top-app-bar__action-item mdc-icon-button",
                "aria-label": "Log Out",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.directory()))
              }, "close"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, _cache[24] || (_cache[24] = [
      _createStaticVNode("<div class=\"mdc-linear-progress__buffer\"><div class=\"mdc-linear-progress__buffer-bar\"></div><div class=\"mdc-linear-progress__buffer-dots\"></div></div><div class=\"mdc-linear-progress__bar mdc-linear-progress__primary-bar\"><span class=\"mdc-linear-progress__bar-inner\"></span></div><div class=\"mdc-linear-progress__bar mdc-linear-progress__secondary-bar\"><span class=\"mdc-linear-progress__bar-inner\"></span></div>", 3)
    ]))), [
      [_directive_progressbar]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["side-layer animate-default", {'open': _ctx.sideLayerOpen }])
    }, [
      _createElementVNode("div", {
        class: "side-layer-skrim animate-default",
        onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.sideLayerOpen = false;})
      }),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[25] || (_cache[25] = _createElementVNode("i", {
            tabindex: "1",
            class: "material-icons",
            "aria-label": "Settings"
          }, "video_settings", -1)),
          _cache[26] || (_cache[26] = _createElementVNode("div", { style: {"margin-left":"8px","flex":"1"} }, "Settings", -1)),
          _createElementVNode("i", {
            style: {"margin-right":"28px"},
            tabindex: "1",
            class: "material-icons mdc-top-app-bar__action-item mdc-icon-button",
            "aria-label": "Settings",
            onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.sideLayerOpen = !_ctx.sideLayerOpen;})
          }, "close")
        ]),
        _createElementVNode("ul", _hoisted_17, [
          _createElementVNode("li", {
            class: "mdc-list-item",
            tabindex: "-1",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleAutoPlay()))
          }, [
            _createElementVNode("div", _hoisted_18, [
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                for: "autoplay-switch",
                style: {"flex":"1","text-align":"left","margin-right":"16px"}
              }, "Auto Play", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "mdc-list-item__ripple" }, null, -1)),
              _createElementVNode("span", _hoisted_19, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mdc-switch__track" }, null, -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mdc-switch__thumb" }, null, -1)),
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.autoPlay,
                      id: "autoplay-switch",
                      class: "mdc-switch__native-control",
                      role: "switch",
                      "aria-checked": _ctx.autoPlay
                    }, null, 8, _hoisted_22)
                  ])
                ])), [
                  [_directive_switch]
                ])
              ])
            ])
          ]),
          _createElementVNode("li", {
            class: "mdc-list-item",
            tabindex: "-1",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleFullScreenVideo()))
          }, [
            _createElementVNode("div", _hoisted_23, [
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                for: "fullScreen-switch",
                style: {"flex":"1","text-align":"left","margin-right":"16px"}
              }, "Display Videos in Full Screen", -1)),
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "mdc-list-item__ripple" }, null, -1)),
              _createElementVNode("span", _hoisted_24, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "mdc-switch__track" }, null, -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mdc-switch__thumb" }, null, -1)),
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.fullScreenVideo,
                      id: "fullScreenVideo-switch",
                      class: "mdc-switch__native-control",
                      role: "switch",
                      "aria-checked": _ctx.fullScreenVideo
                    }, null, 8, _hoisted_27)
                  ])
                ])), [
                  [_directive_switch]
                ])
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[44] || (_cache[44] = _createElementVNode("label", {
                for: "",
                style: {"flex":"1","text-align":"left","margin-right":"16px"},
                class: ""
              }, "Video Quality", -1)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      class: "mdc-radio__native-control",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx._videoQuality) = $event)),
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setVideoQuality(_ctx._videoQuality))),
                      value: "sd",
                      type: "radio",
                      id: "radio-1",
                      name: "videoQualityRadio"
                    }, null, 544), [
                      [_vModelRadio, _ctx._videoQuality]
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "mdc-radio__background" }, [
                      _createElementVNode("div", { class: "mdc-radio__outer-circle" }),
                      _createElementVNode("div", { class: "mdc-radio__inner-circle" })
                    ], -1)),
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "mdc-radio__ripple" }, null, -1))
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("label", { for: "radio-1" }, "SD", -1))
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      class: "mdc-radio__native-control",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx._videoQuality) = $event)),
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setVideoQuality(_ctx._videoQuality))),
                      value: "md",
                      type: "radio",
                      id: "radio-1",
                      name: "videoQualityRadio"
                    }, null, 544), [
                      [_vModelRadio, _ctx._videoQuality]
                    ]),
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "mdc-radio__background" }, [
                      _createElementVNode("div", { class: "mdc-radio__outer-circle" }),
                      _createElementVNode("div", { class: "mdc-radio__inner-circle" })
                    ], -1)),
                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "mdc-radio__ripple" }, null, -1))
                  ]),
                  _cache[40] || (_cache[40] = _createElementVNode("label", { for: "radio-1" }, "MD", -1))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      class: "mdc-radio__native-control",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx._videoQuality) = $event)),
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setVideoQuality(_ctx._videoQuality))),
                      value: "hd",
                      type: "radio",
                      id: "radio-2",
                      name: "videoQualityRadio"
                    }, null, 544), [
                      [_vModelRadio, _ctx._videoQuality]
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "mdc-radio__background" }, [
                      _createElementVNode("div", { class: "mdc-radio__outer-circle" }),
                      _createElementVNode("div", { class: "mdc-radio__inner-circle" })
                    ], -1)),
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "mdc-radio__ripple" }, null, -1))
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("label", { for: "radio-2" }, "HD", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("li", {
            class: "mdc-list-item",
            tabindex: "-1",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleDisplayCaptions()))
          }, [
            _createElementVNode("div", _hoisted_37, [
              _cache[47] || (_cache[47] = _createElementVNode("label", {
                for: "captions-switch",
                style: {"flex":"1","text-align":"left","margin-right":"16px"}
              }, "Display Captions", -1)),
              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "mdc-list-item__ripple" }, null, -1)),
              _createElementVNode("span", _hoisted_38, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "mdc-switch__track" }, null, -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "mdc-switch__thumb" }, null, -1)),
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.displayCaptions,
                      id: "captions-switch",
                      class: "mdc-switch__native-control",
                      role: "switch",
                      "aria-checked": _ctx.displayCaptions
                    }, null, 8, _hoisted_41)
                  ])
                ])), [
                  [_directive_switch]
                ])
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _cache[55] || (_cache[55] = _createElementVNode("label", {
                for: "",
                style: {"flex":"1","text-align":"left","margin-right":"16px"},
                class: ""
              }, "Caption Language", -1)),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      class: "mdc-radio__native-control",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx._captionLanguage) = $event)),
                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setCaptionLanguage(_ctx._captionLanguage))),
                      value: "en",
                      type: "radio",
                      id: "radio-1",
                      name: "captionLanguageRadio"
                    }, null, 544), [
                      [_vModelRadio, _ctx._captionLanguage]
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "mdc-radio__background" }, [
                      _createElementVNode("div", { class: "mdc-radio__outer-circle" }),
                      _createElementVNode("div", { class: "mdc-radio__inner-circle" })
                    ], -1)),
                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "mdc-radio__ripple" }, null, -1))
                  ]),
                  _cache[51] || (_cache[51] = _createElementVNode("label", { for: "radio-1" }, "English", -1))
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _withDirectives(_createElementVNode("input", {
                      class: "mdc-radio__native-control",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx._captionLanguage) = $event)),
                      onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setCaptionLanguage(_ctx._captionLanguage))),
                      value: "es",
                      type: "radio",
                      id: "radio-2",
                      name: "captionLanguageRadio"
                    }, null, 544), [
                      [_vModelRadio, _ctx._captionLanguage]
                    ]),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "mdc-radio__background" }, [
                      _createElementVNode("div", { class: "mdc-radio__outer-circle" }),
                      _createElementVNode("div", { class: "mdc-radio__inner-circle" })
                    ], -1)),
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "mdc-radio__ripple" }, null, -1))
                  ]),
                  _cache[54] || (_cache[54] = _createElementVNode("label", { for: "radio-2" }, "Spanish", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("button", {
            class: "mdc-button mdc-button--raised",
            style: {"width":"100%"},
            onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.deleteDownloadedPlaylists();})
          }, _cache[56] || (_cache[56] = [
            _createElementVNode("span", { class: "mdc-button__ripple" }, null, -1),
            _createElementVNode("i", {
              class: "material-icons mdc-button__icon",
              "aria-hidden": "true"
            }, "delete_sweep", -1),
            _createElementVNode("span", { class: "mdc-button__label clip" }, "Delete All Downloaded Playlists", -1)
          ]))
        ])
      ])
    ], 2),
    _createVNode(_component_router_view),
    _cache[57] || (_cache[57] = _createElementVNode("div", {
      class: "mdc-snackbar",
      style: {"z-index":"1000","bottom":"40px"}
    }, [
      _createElementVNode("div", {
        class: "mdc-snackbar__surface",
        style: {"border":"solid 2px #444","color":"#fff"}
      }, [
        _createElementVNode("div", {
          class: "mdc-snackbar__label",
          style: {"text-align":"left"},
          role: "status",
          "aria-live": "polite"
        }),
        _createElementVNode("div", { class: "mdc-snackbar__actions" }, [
          _createElementVNode("button", {
            type: "button",
            class: "mdc-button mdc-snackbar__action",
            style: {"color":"#5ba7f2 !important"}
          }, [
            _createElementVNode("div", { class: "mdc-button__ripple" }),
            _createElementVNode("span", { class: "mdc-button__label" })
          ])
        ])
      ])
    ], -1))
  ]))
}